
import store from '@/store/index'
import Vue from 'vue'
import CostGuardNotice from '@/components/CostGuardNotice.vue'
import IntroDrawer from '@/components/IntroDrawer.vue'
import { introContext, publicIntro, introButtonText } from '@/utils/intro'
import { costGuardCode } from '@/utils/guestSession'
import { BlobDto, CreateProfileSourceInput, ExecuteMatchingInput, KeywordProcessContentInput, MatchRequest, ProfileSource, ProfileUpdatedRequest, SendMarkdownEmailInput, SyncUnitToUserInput, TmpUser, UserDto, UserDtoBindingStatusEnum } from '@chainsight/networker-backend-axios-sdk';
import i18n from '@/plugins/i18n'
import { translateRecordValues, translateTexts } from '@/utils/translator'
import { tr } from 'date-fns/locale';

export default Vue.extend({
	name: 'BusinessMatchHome',
	components: { CostGuardNotice, IntroDrawer,
	},
	data() {
		return {
            costCode: '',
            introOpen: false,
            introContextData: {} as any,
			overlay: false,
			isPdfAnalyzing: false,
			isKeywordAnalyzing: false,
			progressStatusText: '',
			isUploadSourceMode: false,
			isInputKeywordMode: true,
			isWebsiteUrlMode: false,
			isMatching: false,
			snackbar: false,
			profileReminderSnackbar: false,
			pendingProfileReminderSnackbar: false,
			onboardingDialog: false,
			onboardingStep: 1,
			isUrlValid: false,
			isTopLevelDomain: false,
			fullName: '',
			jobTitle: '',
			companyWebsiteUrl: '',
			companyName:'',
			currentEmail: '',
			phone: '',
			bio: '',
			industry: [] as string[],
			industrySearchText: '',
			industryFilteredList: [] as string[],
			newQueryKeyword: '',
			snackbarText: '',
			snackbarColor: '',
			snackbarLinkText: '',
			snackbarLinkRoute: '',
			snackbarTextAfter: '',
			progressValue: 0,
			interval: 0,
			email:'',
            linkedUrl: '',
			websiteUrlInput: '',
			pdf: null as File | null,
			isDragging: false,
			pdfBlob: null as unknown as BlobDto,
			matchRequest: {} as MatchRequest,
			profileSource: {} as ProfileSource,
			tmpUser: {} as TmpUser,
			userDto: { ...((!store.state.track.trackDto?.id || store.state.track.trackDto.id === '0') ? (store.state.user.userDto || {}) : {}) } as UserDto,
			selectedExampleTab: 0,
			showExampleDropdown: false,
			platformIndustries: [] as string[],
			platformIndustryKeyValue: {} as Record<string, string>,
			translatedToOriginalIndustryMap: {} as Record<string, string>,
			facetDto: {} as any,
			homeRecommendation: {} as any,
			groupedRecommendations: [] as { queryText: string; matches: any[] }[],
            recommendationsDestroyed: false,
            recommendationTranslationSequence: 0,
			detailDrawer: false,
			mobileDetailDrawer: false,
			recommendationDetail: {} as any,
			demandDescriptions: [] as string[],
			supplyDescriptions: [] as string[],
			summaryDescriptions: [] as string[],
			// Email Dialog 相關
			sendEmailDialog: false,
			sendEmailSubject: '',
			sendEmailContent: '',
			sendEmailFixedContent: '',
			sendEmailSharingUrl: ''
		};
	},
	computed: {
        isPublicIntro(): boolean { return publicIntro(this.trackDto?.id, this.userDto?.isPaidMember) },
        introLabel(): string { return introButtonText(this.$vuetify.breakpoint.xs) },
		trackDto(){
			return store.state.track.trackDto
		},
		user() {
			return store.state.user;
		},
		exampleCategories() {
			const trackId = this.trackDto?.id ?? '';
			let examplesKey = 'other';
			if (['8', '20'].includes(trackId)) {
				examplesKey = 'track8';
			} else if (['4', '7'].includes(trackId)) {
				examplesKey = 'track47';
			}
			const examples = this.$t(`businessMatchHome.examples.${examplesKey}`) as Record<string, any>;

			return Object.entries(examples).map(([key, value]) => ({
				title: value.title,
				examples: value.examples
			}));
		},
		allExamples(): string[] {
			const categories = this.exampleCategories as { title: string; examples: string[] }[];
			const all: string[] = [];
			categories.forEach(cat => {
				if (Array.isArray(cat.examples)) {
					cat.examples.forEach(ex => all.push(ex));
				}
			});
			return all;
		},
		industryItemsLimited(): { text: string; value: string; disabled: boolean }[] {
			const industryList: string[] = Array.isArray(this.industry) ? this.industry : [];
			const isMax = industryList.length >= 5;
			const baseList: string[] = this.industrySearchText?.length > 0
				? (this.industryFilteredList ?? []) : (this.platformIndustries || []);

			return baseList.map((item: string) => ({
				text: item,
				value: item,
				disabled: isMax && !this.industry.includes(item),
			}));
		},
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
	},
	beforeDestroy() {
        this.recommendationsDestroyed = true;
        this.recommendationTranslationSequence++;
		document.removeEventListener('click', this.handleClickOutside);
	},
	methods: {
        openIntroForm(item: any, source = 'results_drawer') {
            this.detailDrawer = false; this.mobileDetailDrawer = false
            this.introContextData = introContext(item, this.matchRequest, this.newQueryKeyword, source)
            this.introOpen = true
        },
		capitalizeFirst(text: string): string {
			if (!text) return ''
			return text.charAt(0).toUpperCase() + text.slice(1)
		},
		handleClickOutside(event: MouseEvent) {
			const target = event.target as HTMLElement;
			const inputContainers = this.$el.querySelectorAll('.keyword-textarea');
			const dropdowns = this.$el.querySelectorAll('.example-dropdown');

			const isInsideInput = Array.from(inputContainers).some(el => el.contains(target));
			const isInsideDropdown = Array.from(dropdowns).some(el => el.contains(target));

			if (!isInsideInput && !isInsideDropdown) {
				this.showExampleDropdown = false;
			}
		},
		selectExample(example: string) {
			this.newQueryKeyword = example;
			this.showExampleDropdown = false;
		},
		async openRecommendationDetail(item: any) {
			this.recommendationDetail = item;
			// 提取 demands 和 supplies 的描述
			this.demandDescriptions = (item.demands || []).map((d: any) => d.description ?? d.description_short ?? d.descriptionShort).filter(Boolean);
			this.supplyDescriptions = (item.supplies || []).map((s: any) => s.description ?? s.description_short ?? s.descriptionShort).filter(Boolean);
			// 提取 summaries（配對理由）
			this.summaryDescriptions = (item.summaries || []).filter(Boolean);

			// 取得 entityIndustry
			const entityIndustry: string[] = item.entityIndustry || [];

			// 翻譯 demandDescriptions、supplyDescriptions、summaryDescriptions 和 entityIndustry
			const demandCount = this.demandDescriptions.length;
			const supplyCount = this.supplyDescriptions.length;
			const summaryCount = this.summaryDescriptions.length;
			const industryCount = entityIndustry.length;

			if (demandCount > 0 || supplyCount > 0 || summaryCount > 0 || industryCount > 0) {
				let targetLang = 'en-US';
				if (i18n.locale === 'zh') {
					targetLang = 'zh-Hant';
				} else if (i18n.locale === 'ja') {
					targetLang = 'ja-JP';
				}

				try {
					const allTexts = this.demandDescriptions.concat(this.supplyDescriptions).concat(this.summaryDescriptions).concat(entityIndustry);
					const translated = await translateTexts(allTexts, targetLang);

					// 分配翻譯結果
					this.demandDescriptions = translated.slice(0, demandCount);
					this.supplyDescriptions = translated.slice(demandCount, demandCount + supplyCount);
					this.summaryDescriptions = translated.slice(demandCount + supplyCount, demandCount + supplyCount + summaryCount);
					this.recommendationDetail.entityIndustry = translated.slice(demandCount + supplyCount + summaryCount);
				} catch (error) {
                this.costCode = costGuardCode(error)
					console.error('翻譯 demands/supplies/summaries/industry 失敗', error);
				}
			}

			// 根據螢幕大小決定打開哪個 drawer
			if (this.$vuetify.breakpoint.smAndUp) {
				this.detailDrawer = true;
			} else {
				this.mobileDetailDrawer = true;
			}
		},
		async getMe(){
			try {
				const resp = await this.api$.authApi.getMe();
				this.userDto = resp.data.data as UserDto;

				this.fullName = (this.userDto.firstName || this.userDto.lastName)
								? [this.userDto.firstName, this.userDto.lastName].filter(Boolean).join(' ')
								: ''
				this.jobTitle = this.userDto.companyTitle?.join(', ') ?? '';
				this.companyName = this.userDto.companyName ?? '';
				this.companyWebsiteUrl = this.userDto.companyUrl?.split('https://')[1] ?? '';
				this.currentEmail = this.userDto.currentEmail ?? '';
				this.phone = this.userDto.phone ?? '';
				this.bio = this.userDto.bioDescription ?? '';
				// 保留英文行業名稱，稍後在 created() 中轉換（等 getPlatformIndustryList() 完成後）

				if(this.userDto.bindingStatus === UserDtoBindingStatusEnum.Unbound){
					// 先呼叫 syncUnitToUser API
					const syncUnitToUserInput: SyncUnitToUserInput = {
						email: this.userDto.email,
						productTrackId: this.trackDto?.id,
					}
					const syncResp = await this.api$.profileApi.syncUnitToUser(this.userDto.id as string, syncUnitToUserInput)
					this.userDto = syncResp.data.data ?? this.userDto
					store.commit('SET_USER_DTO', this.userDto)

					if(this.userDto.bindingStatus === UserDtoBindingStatusEnum.Bound){
						this.pendingProfileReminderSnackbar = true
					}
				}

				if(this.userDto.bindingStatus !== UserDtoBindingStatusEnum.Bound && this.userDto.bindingStatus !== UserDtoBindingStatusEnum.NotRequired && (this.fullName.length == 0 || this.phone.length == 0 || this.currentEmail.length == 0)){
					this.onboardingDialog = true
				}
			} catch (e) {
				console.error(e);
			}
		},
		checkUrl(value) {
			if (!value) return true
			this.isTopLevelDomain = false;
			
			const topLevelDomainRegex = /^(https:\/\/)([a-zA-Z0-9-]+\.[a-zA-Z]{2,})$/;
			if (topLevelDomainRegex.test(value)) {
				this.isTopLevelDomain = true;
			}
			
			const urlRegex = /^(https:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
			if (urlRegex.test(value)) {
				this.isUrlValid = true;
				return true;
			}
			this.isUrlValid = false
			return this.$t('businessMatchHome.validation.invalidUrlError');
		},
		autoHttps(){
			if(this.websiteUrlInput.length == 0) return
			else if(this.websiteUrlInput.startsWith('http://')){
				this.websiteUrlInput = 'https://' + this.websiteUrlInput.split('http://')[1]
			} else if(!this.websiteUrlInput.startsWith('https://')){
				this.websiteUrlInput = 'https://' + this.websiteUrlInput
			}
		},
		handleKeydownForKeywordMatch(event: KeyboardEvent) {
			if (this.newQueryKeyword.trim().length > 0 && event.key === 'Enter' ) {
				this.keywordProcessContent()
			}
		},
		handleKeydownForUrlMatch(event : KeyboardEvent) {
			if (this.isUrlValid && event.key === 'Enter' ) {
				this.pdfProcessContent()
			}
		},
		triggerFileInput() {
			const fileInput = this.$refs.fileInput as HTMLInputElement
			if (fileInput) {
				fileInput.click()
			} else {
				console.error('File input reference not found.')
			}
		},
		handleFileUpload(event) {
			if (event.target.files[0]) {
				this.pdf = event.target.files[0]
			}
		},
		handleDragEnter(event) {
			event.preventDefault()
			event.stopPropagation()
			this.isDragging = true
		},
		handleDragOver(event) {
			event.preventDefault()
			event.stopPropagation()
		},
		handleDragLeave(event) {
			event.preventDefault()
			event.stopPropagation()
			const rect = event.currentTarget.getBoundingClientRect()
			const x = event.clientX
			const y = event.clientY
			if (x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) {
				this.isDragging = false
			}
		},
		handleDrop(event) {
			event.preventDefault()
			event.stopPropagation()
			this.isDragging = false
			
			const files = event.dataTransfer?.files
			if (files && files.length > 0) {
				const file = files[0]
				if (file.type === 'application/pdf') {
					this.pdf = file
				} else {
					this.snackbar = true
					this.snackbarText = String(this.$t('businessMatchHome.validation.pdfOnlyError'))
					this.snackbarColor = 'error'
				}
			}
		},
		initialInput(){
			this.newQueryKeyword = ''
			this.websiteUrlInput = ''
			this.pdf = null
		},
		titleSwitcher(){
			const trackId = this.trackDto?.id ?? ''
			if (trackId === '0') return ''
			if (trackId === '1') return 'YC'
			if (trackId === '4') return 'CES 2025'
			if (trackId === '7') return 'COMPUTEX'
			if (['8', '20'].includes(trackId)) return 'IFA'
			if (['2', '3', '5', '6', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'].includes(trackId)) return 'BNI'
			return ''
		},
		async completeOnboarding() {
			this.overlay = true;
			this.onboardingDialog = false;

			// 儲存更新前的狀態
			const beforeIsPaidMember = this.userDto?.isPaidMember || false
			const beforeIsFreeUpgradeUsed = this.userDto?.isFreeUpgradeUsed || false

			// 將翻譯後的行業名稱轉換回英文原文
			const industryInEnglish = this.industry?.map(translatedIndustry => {
				return this.translatedToOriginalIndustryMap[translatedIndustry] || translatedIndustry
			}) || [];

			const profileUpdatedRequest: ProfileUpdatedRequest = {
				firstName: this.fullName,
				lastName: '',
				companyName: this.companyName,
				companyUrl: this.companyWebsiteUrl?.trim() ? 'https://' + this.companyWebsiteUrl.trim() : '',
				companyTitle: this.jobTitle?.trim()
					? this.jobTitle.split(',').map(t => t.trim()).filter(Boolean)
					: undefined,
				companyIndustry: industryInEnglish,
				currentEmail: this.currentEmail,
				phone: this.phone,
				bioDescription: this.bio,
				productTrackId: this.trackDto?.id,
				isDelete: this.userDto?.isDelete,
			};

			try {
				const updateProfileResp = await this.api$.profileApi.updateProfile(this.user.userDto?.id as string, profileUpdatedRequest);
				if (updateProfileResp.data.data) {
					this.userDto = updateProfileResp.data.data;
				}

				// const enhanceUserProfileResp = await this.api$.profileApi.enhanceUserProfile(this.user.userDto?.id as string, '0');
				// if (enhanceUserProfileResp.data.data) {
				// 	this.userDto = enhanceUserProfileResp.data.data;
				// }

				// 檢查是否從 false 變成 true
				const afterIsPaidMember = this.userDto?.isPaidMember || false
				const afterIsFreeUpgradeUsed = this.userDto?.isFreeUpgradeUsed || false

				if (!beforeIsPaidMember && afterIsPaidMember && !beforeIsFreeUpgradeUsed && afterIsFreeUpgradeUsed) {
					// 觸發事件顯示 free trial banner
					this.eventHub$.$emit('showFreeTrialBanner')
					// 同時觸發 AvatarMenu 更新會員狀態
					this.eventHub$.$emit('avatarMenuGetUser')
				}
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}

			// 若 bindingStatus 是 cannot_bind，用 onboarding 填的 email 再打一次 syncUnitToUser API
			if(this.userDto.bindingStatus === UserDtoBindingStatusEnum.CannotBind){
				try {
					const syncUnitToUserInput: SyncUnitToUserInput = {
						email: this.currentEmail,
						productTrackId: this.trackDto?.id,
					}
					const syncResp = await this.api$.profileApi.syncUnitToUser(this.userDto.id as string, syncUnitToUserInput)
					this.userDto = syncResp.data.data ?? this.userDto
					store.commit('SET_USER_DTO', this.userDto)

					if(this.userDto.bindingStatus === UserDtoBindingStatusEnum.Bound){
						this.profileReminderSnackbar = true
					}
				} catch (error) {
                this.costCode = costGuardCode(error)
					console.error(error)
				}
			}

			this.overlay = false;
		},
		async uploadPDF(){
			let createBlobResp
			try{
				createBlobResp = await this.api$.blobApi.createBlob(this.pdf)
				this.pdfBlob = createBlobResp?.data?.data
			}catch (error) {
                this.costCode = costGuardCode(error)
				this.snackbar = true
				this.snackbarText = String(this.$t('businessMatchHome.errors.pdfUploadFailed'));
				this.snackbarColor = 'error'
				console.error(error)
			}
		},
		async pdfProcessContent(){
			clearInterval(this.interval)
			
			this.isPdfAnalyzing = true
			this.progressValue = 0
			
			let createProfileSourceResp
			let pdfProcessContentResp
			let executeMatchingResp
			try{
				if(this.pdf != null){
					await this.uploadPDF()
				}
				const createProfileSourceInput : CreateProfileSourceInput = {
					searchKeywords: this.email.split('@')[1]?.split('.')[0],
					productTrackId: this.trackDto?.id ? this.trackDto.id : '0',
					linkedinUrl: this.linkedUrl.split('?')[0],
					webUrl: this.websiteUrlInput,
					...(this.pdf && { pdfBlobId: this.pdfBlob.id })
				}

				createProfileSourceResp = await this.api$.businessMatchApi.createProfileSource(this.userDto.id as string, createProfileSourceInput)
				this.profileSource = createProfileSourceResp.data.data
				pdfProcessContentResp = await this.api$.businessMatchApi.pdfProcessContent(this.userDto.id as string, this.trackDto?.id ? this.trackDto.id : '0', this.profileSource.id as string)
				this.matchRequest = pdfProcessContentResp.data.data

				// this.progressValue = 100
				// if(pdfProcessContentResp.data.isSuccess){
				// 	setTimeout(() => {
				// 		this.$router.push({name:'BusinessMatchContent'})
				// 	},	150)
				// }

				if (!this.matchRequest.simplifiedDemands?.length && !this.matchRequest.simplifiedSupplies?.length) {
					this.progressValue = 100
					setTimeout(() => {
						this.$router.push({name:'BusinessMatchContent'})
					}, 150)
					return
				}
				
				const executeMatchingInput : ExecuteMatchingInput = {
					simplifiedDemands: this.matchRequest.simplifiedDemands,
					simplifiedSupplies: this.matchRequest.simplifiedSupplies
				}
				
				executeMatchingResp = await this.api$.businessMatchApi.executeMatching(this.user.userDto?.id as string, this.trackDto?.id ? this.trackDto.id : '0', executeMatchingInput)

				this.progressValue = 100
				if(executeMatchingResp.data.isSuccess){
					setTimeout(() => {
						this.$router.push({name:'BusinessMatchResults'})
					},	150)
				}
			} catch (error: any) {
                this.costCode = costGuardCode(error)
				setTimeout(() => {
					this.snackbar = true
					const errorMessage = error?.response?.data?.error?.message || "";
					const apiErrorCode = error?.response?.data?.error?.apiErrorCode || "";
					const status = error?.response?.status;

					if (status === 400 && apiErrorCode === "EMPTY_QUERY") {
						this.snackbarText = String(this.$t('businessMatchHome.errors.emptyQueryError'));
					} else if (this.websiteUrlInput && this.websiteUrlInput.trim().length > 0) {
						this.snackbarText = String(this.$t('businessMatchHome.errors.incompleteUrlError'));
					} else if (errorMessage.toLowerCase().includes("openai issue")) {
						this.snackbarText = String(this.$t('businessMatchHome.errors.openaiUnavailable'));
					} else {
						this.snackbarText = String(this.$t('businessMatchHome.errors.fetchMatchFailed'));
					}
					this.snackbarColor = 'error'
				},	100)

				console.error(error)
			}
			this.isPdfAnalyzing = false
		},
		async keywordProcessContent(){
			clearInterval(this.interval)
			
			this.isKeywordAnalyzing = true
			this.progressValue = 0

			let keywordProcessContentResp
			let executeMatchingResp
			try{
				const keywordProcessContentInput : KeywordProcessContentInput = {
					keyword: this.newQueryKeyword,
				}

				keywordProcessContentResp = await this.api$.businessMatchApi.keywordProcessContent(this.userDto.id as string, this.trackDto?.id ? this.trackDto.id : '0', keywordProcessContentInput)
				this.matchRequest = keywordProcessContentResp.data.data

				if (!this.matchRequest.simplifiedDemands?.length && !this.matchRequest.simplifiedSupplies?.length) {
					this.progressValue = 100
					setTimeout(() => {
						this.$router.push({name:'BusinessMatchContent'})
					}, 150)
					return
				}
				
				const executeMatchingInput : ExecuteMatchingInput = {
					simplifiedDemands: this.matchRequest.simplifiedDemands,
					simplifiedSupplies: this.matchRequest.simplifiedSupplies
				}
				
				executeMatchingResp = await this.api$.businessMatchApi.executeMatching(this.user.userDto?.id as string, this.trackDto?.id ? this.trackDto.id : '0', executeMatchingInput)

				this.progressValue = 100
				if(executeMatchingResp.data.isSuccess){
					setTimeout(() => {
						this.$router.push({name:'BusinessMatchResults'})
					},	150)
				}
			} catch (error: any) {
                this.costCode = costGuardCode(error)
				setTimeout(() => {
					this.snackbar = true
					const errorMessage = error?.response?.data?.error?.message || "";
					if (errorMessage.toLowerCase().includes("openai issue")) {
						this.snackbarText = String(this.$t('businessMatchHome.errors.openaiUnavailable'));
					} else {
						this.snackbarText = String(this.$t('businessMatchHome.errors.fetchMatchFailed'));
					}
					this.snackbarColor = 'error'
				},	100)
				console.error(error)
			}
			this.isKeywordAnalyzing = false
		},
		nextStep() {
			this.onboardingStep = 2;
		},
		previousStep() {
			this.onboardingStep = 1;
		},
		filterIndustries() {
			if (!this.industrySearchText || this.industrySearchText.trim() === '') {
				this.industryFilteredList = [];
				return;
			}

			const searchLower = this.industrySearchText.toLowerCase();
			this.industryFilteredList = this.platformIndustries.filter((industry: string) =>
				industry.toLowerCase().includes(searchLower)
			);
		},
		normalizeToKeyValue(data: any): Record<string, string> | undefined {
			if (Array.isArray(data)) {
				return data.reduce((acc: Record<string, string>, item: any) => {
					if (typeof item === 'string') {
						acc[item] = item;
					}
					return acc;
				}, {});
			}
			return undefined;
		},
		async getPlatformIndustryList() {
			let getFilterListResp
			try {
				getFilterListResp = await this.api$.platformApi.getFilterList()
				this.facetDto = getFilterListResp.data.data

				this.platformIndustryKeyValue = this.normalizeToKeyValue(this.facetDto.industries) ?? {}

				if (i18n.locale === 'zh') {
					await translateRecordValues(this.platformIndustryKeyValue, 'zh-Hant')
				} else if (i18n.locale === 'en') {
					await translateRecordValues(this.platformIndustryKeyValue, 'en-US')
				} else if (i18n.locale === 'ja') {
					await translateRecordValues(this.platformIndustryKeyValue, 'ja-JP')
				}

				this.platformIndustries = Object.values(this.platformIndustryKeyValue ?? {})

				// 建立反向 map：翻譯後的文字 -> 英文原文
				this.translatedToOriginalIndustryMap = {}
				for (const [originalKey, translatedValue] of Object.entries(this.platformIndustryKeyValue)) {
					this.translatedToOriginalIndustryMap[translatedValue] = originalKey
				}
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error)
			}
		},
		async getHomeRecommendation() {
			try {
				const trackId = this.trackDto?.id === '0' ? undefined : this.trackDto?.id
				const { data } = await this.api$.businessMatchApi.getHomeRecommendations(this.user.userDto?.id as string, 4, trackId)
				this.homeRecommendation = data.data

				// API 回傳的 personalizedRecommendations 已經是分群好的結構
				this.groupedRecommendations = this.homeRecommendation?.personalizedRecommendations || []

				// 加入各 track 的新用戶群組 (已註解)
				// const trackGroups = [
				// 	{ users: this.homeRecommendation?.recentTrack5Users, key: 'track5' },
				// 	{ users: this.homeRecommendation?.recentTrack6Users, key: 'track6' },
				// 	{ users: this.homeRecommendation?.recentTrack7Users, key: 'track7' },
				// 	{ users: this.homeRecommendation?.track0Users, key: 'track0' }
				// ]
				// trackGroups
				// 	.filter(g => g.users?.length)
				// 	.forEach(g => this.groupedRecommendations.push({
				// 		queryText: String(this.$t(`businessMatchHome.trackUserGroups.${g.key}`)),
				// 		matches: g.users
				// 	}))

                if (!this.trackDto?.id || this.trackDto.id === '0') {
                    this.overlay = false;
                    void this.translateRecommendations();
                } else await this.translateRecommendations()
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error)
			}
		},
		async translateRecommendations() {
			if (!this.groupedRecommendations || this.groupedRecommendations.length === 0) return
            const groups = this.groupedRecommendations, locale = i18n.locale;
            const sequence = ++this.recommendationTranslationSequence;
            const publicTrack = !this.trackDto?.id || this.trackDto.id === '0';

			// 根據 i18n.locale 決定目標語言
			let targetLang = 'en-US'
			if (i18n.locale === 'zh') {
				targetLang = 'zh-Hant'
			} else if (i18n.locale === 'ja') {
				targetLang = 'ja-JP'
			}

			// 收集所有需要翻譯的文字和對應的 setter
			const texts: string[] = []
			const setters: ((t: string) => void)[] = []

			this.groupedRecommendations.forEach((group: any) => {
				// 翻譯 queryText
				if (typeof group.queryText === 'string' && group.queryText) {
					texts.push(group.queryText)
					setters.push(t => (group.queryText = t))
				}

				// 翻譯 entityDescription
				if (Array.isArray(group.matches)) {
					group.matches.forEach((item: any) => {
						if (typeof item.entityDescription === 'string' && item.entityDescription) {
							texts.push(item.entityDescription)
							setters.push(t => (item.entityDescription = t))
						}
					})
				}
			})

			if (texts.length > 0) {
				try {
					const translated = await translateTexts(texts, targetLang)
                    if (publicTrack && (this.recommendationsDestroyed || groups !== this.groupedRecommendations
                        || sequence !== this.recommendationTranslationSequence || locale !== i18n.locale)) return;
					translated.forEach((t, i) => setters[i](t))
					// 觸發 Vue 響應式更新
					this.groupedRecommendations = this.groupedRecommendations.slice()
				} catch (error) {
                this.costCode = costGuardCode(error)
					console.error('翻譯推薦內容失敗', error)
				}
			}
		},
		async addUnitAsFriend(unitId: number) {
			try {
				const response = await this.api$.userFriendApi.addUnitAsFriend(this.user.userDto?.id as string, unitId)
				return response.data.data
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Failed to add unit as friend:', error)
				return null
			}
		},
		async handleConnect(item: any) {
            if (this.isPublicIntro) { this.openIntroForm(item); return }
			const unitId = item.unitId
			const productTrackId = item.productTrackId

			if (!unitId) return

			// 檢查使用者個人資料是否完整
			if (!this.userDto?.companyTitle || !this.userDto?.email || !this.userDto?.companyName) {
				this.snackbarColor = 'warning'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.incompleteProfile'))
				this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.goToProfile'))
				this.snackbarLinkRoute = '/profile'
				this.snackbarTextAfter = ''
				this.snackbar = true
				return
			}

			// 若已聯繫過，顯示提示訊息並返回
			if (item.savedContact === true) {
				this.snackbarColor = '#1976D1'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.alreadyContacted'))
				this.snackbarLinkText = ''
				this.snackbarLinkRoute = ''
				this.snackbarTextAfter = ''
				this.snackbar = true
				return
			}

			this.overlay = true

			// 關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false
			try {
				if (productTrackId === '0') {
					const toEmail = item.email

					// 同時呼叫 addUnitAsFriend
					const promises: Promise<any>[] = [
						this.addUnitAsFriend(unitId)
					]
					await Promise.all(promises)

					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const userName = item.name || ''

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.connectUser.subject'))
						let content = String(this.$t('emailTemplates.connectUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						content = content
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)

						// 條件式行：Title
						if (senderTitle) {
							content = content.replace(/\{sender_title\}/g, senderTitle)
						} else {
							content = content.replace(/\n- Title: \{sender_title\}/g, '')
						}

						// 條件式行：Looking for
						if (senderLookingFor) {
							content = content.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							content = content.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式行：Offers
						if (senderOffers) {
							content = content.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							content = content.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// [Login to Accept →] 後面加入 NonLoginChatRoom 連結
						content = content.replace('[Login to Accept →]', `[Login to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content
						})
					}

					// 標記為已聯繫
					item.savedContact = true

					// 顯示成功訊息
					this.snackbarColor = '#1976D1'
					this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessConnected'))
					this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessStartConversation'))
					this.snackbarLinkRoute = '/chat'
					this.snackbarTextAfter = ''
					this.snackbar = true
				} else {
					const toEmail = item.email

					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						let userName = ''
						if (['4', '7'].includes(item.productTrackId ?? '')) {
							userName = item.entityName || ''
						} else {
							userName = item.name || ''
						}

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderIndustry = userDto?.companyIndustry?.join(', ') || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''
						const senderMatchReasonItems = item.summaries?.filter(Boolean) || []
						const senderMatchReason = senderMatchReasonItems.length > 0 ? '\n  - ' + senderMatchReasonItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.connectNonUser.subject'))
						let content = String(this.$t('emailTemplates.connectNonUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						content = content
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)
							.replace(/\{sender_industry\}/g, senderIndustry)

						// 條件式行：Title（在 greeting 行中）
						if (senderTitle) {
							content = content.replace(/\{sender_title\}/g, senderTitle)
						} else {
							content = content.replace(/, \{sender_title\}/g, '')
						}

						// 條件式行：Looking for
						if (senderLookingFor) {
							content = content.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							content = content.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式行：Offers
						if (senderOffers) {
							content = content.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							content = content.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// Why they want to connect
						if (senderMatchReason) {
							content = content.replace(/\{sender_match_reason\}/g, senderMatchReason)
						} else {
							content = content.replace(/\n- Why they want to connect: \{sender_match_reason\}/g, '')
						}

						// [Register to Accept →] 後面加入 NonLoginChatRoom 連結
						content = content.replace('[Register to Accept →]', `[Register to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content
						})
					}

					// 標記為已聯繫
					item.savedContact = true

					// 顯示成功訊息
					this.snackbarColor = '#1976D1'
					this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessMyContacts'))
					this.snackbarLinkRoute = '/match/my-contacts'
					if (toEmail) {
						this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessAddedTo'))
						this.snackbarTextAfter = String(this.$t('businessMatchResults.detailDrawer.connectSuccessNotifiedByEmail'))
					} else {
						this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessConnectedAddedTo'))
						this.snackbarTextAfter = ''
					}
					this.snackbar = true
				}
			} finally {
				this.overlay = false
			}
		},
		async handleMessage(item: any) {
			const unitId = item.unitId
			const productTrackId = item.productTrackId

			if (!unitId) return

			this.overlay = true

			// 關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false
			try {
				if (productTrackId === '0') {
					const toEmail = item.email

					// 同時呼叫 addUnitAsFriend
					const promises: Promise<any>[] = [
						this.addUnitAsFriend(unitId)
					]
					const [friendResponse] = await Promise.all(promises)

					// 寄送 messageUser 模板信件
					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const userName = item.name || ''

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.messageUser.subject'))
						let emailContent = String(this.$t('emailTemplates.messageUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						emailContent = emailContent
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)

						// 條件式：Title
						if (senderTitle) {
							emailContent = emailContent.replace(/\{sender_title\}/g, senderTitle)
						} else {
							emailContent = emailContent.replace(/\n- Title: \{sender_title\}/g, '')
						}

						// 條件式：Looking for
						if (senderLookingFor) {
							emailContent = emailContent.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							emailContent = emailContent.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式：Offers
						if (senderOffers) {
							emailContent = emailContent.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							emailContent = emailContent.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// 替換連結（使用 NonLoginChatRoom URL）
						emailContent = emailContent.replace('[Login to Accept →]', `[Login to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content: emailContent
						})
					}

					// 跳轉到 chat
					if (friendResponse?.friendUserId) {
						localStorage.setItem('TARGET_USER_ID', friendResponse.friendUserId)
						this.$router.push('/chat')
					}
				} else {
					const toEmail = item.email

					if (toEmail) {
						// 建立 sharingUser
						const userId = this.user.userDto?.id as string
						const sharingResponse = await this.api$.sharingUserApi.createSharingUser(userId)
						const sharingId = sharingResponse.data.data?.id
						let baseUrl = process.env.VUE_APP_BASE_URL as string
						if (!baseUrl.includes('localhost') && this.trackDto?.name && this.trackDto?.id !== '0') {
							baseUrl = baseUrl.replace('//ws', `//${this.trackDto.name}.ws`)
						}
						const sharingUrl = `${baseUrl}/nl-match/profile-sharing/${sharingId}`

						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						let userName = ''
						if (['4', '7'].includes(item.productTrackId ?? '')) {
							userName = item.entityName || ''
						} else {
							userName = item.name || ''
						}

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.messageNonUser.subject'))
						let templateContent = String(this.$t('emailTemplates.messageNonUser.content'))
						let fixedContent = String(this.$t('emailTemplates.messageNonUser.fixedContent'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						templateContent = templateContent
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_title\}/g, senderTitle)
							.replace(/\{sender_company\}/g, senderCompany)

						// 替換連結
						templateContent = templateContent.replace('[View Business Card →]', `[View Business Card →]: ${sharingUrl}`)
						fixedContent = fixedContent.replace('[Register to Message →]', `[Register to Message →]: ${nonLoginChatUrl}`)

						// 帶入主旨、內文、固定區塊
						this.sendEmailSubject = subject
						this.sendEmailContent = templateContent
						this.sendEmailFixedContent = fixedContent
						this.sendEmailSharingUrl = sharingUrl

						// 打開 dialog
						this.sendEmailDialog = true
					}
				}
			} finally {
				this.overlay = false
			}
		},
		linkifyText(text: string): string {
			const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			return escaped.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" class="primary--text font-weight-medium" style="word-break: break-all;">$1</a>')
		},
		async sendTemplateEmail(input: SendMarkdownEmailInput) {
			try {
				await this.api$.emailApi.sendEmail1(input)
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Failed to send email:', error)
			}
		},
		async openSendEmailDialog(item: any) {
			// 先關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			try {
				// 先建立 sharing user 取得分享連結
				const userId = this.user.userDto?.id as string
				const response = await this.api$.sharingUserApi.createSharingUser(userId)
				const sharingId = response.data.data?.id

				// 若不是 localhost，在 // 和 ws 之間加入 trackDto.name.
				let baseUrl = process.env.VUE_APP_BASE_URL as string
				if (!baseUrl.includes('localhost') && this.trackDto?.name && this.trackDto?.id !== '0') {
					baseUrl = baseUrl.replace('//ws', `//${this.trackDto.name}.ws`)
				}
				this.sendEmailSharingUrl = `${baseUrl}/nl-match/profile-sharing/${sharingId}`
				this.sendEmailFixedContent = `[View Business Card →]: ${this.sendEmailSharingUrl}`

				this.sendEmailDialog = true
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Failed to create sharing user:', error)
			}
		},
		closeSendEmailDialog() {
			this.sendEmailDialog = false
		},
		async sendEmailToUnit() {
			if (!this.sendEmailSubject.trim() || !this.sendEmailContent.trim()) return

			// 先關閉 dialog
			this.closeSendEmailDialog()
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			this.overlay = true
			try {
				const fullContent = `${this.sendEmailContent}\n\n${this.sendEmailFixedContent}`

				const requestBody = {
					userId: this.user.userDto?.id as string,
					unitId: this.recommendationDetail.unitId,
					productTrackId: this.trackDto?.id,
					subject: this.sendEmailSubject,
					content: fullContent,
				}

				await this.api$.emailApi.sendEmailToUnit(requestBody)

				// 清空主旨和信件內容
				this.sendEmailSubject = ''
				this.sendEmailContent = ''
				this.sendEmailFixedContent = ''

				// 顯示成功訊息
				this.snackbarColor = '#1976D1'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessAddedTo'))
				this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessMyContacts'))
				this.snackbarLinkRoute = '/match/my-contacts'
				this.snackbarTextAfter = String(this.$t('businessMatchResults.detailDrawer.connectSuccessNotifiedByEmail'))
				this.snackbar = true
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Failed to send email:', error)
				// 顯示失敗訊息
				this.snackbarColor = 'error'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.emailSendFailed'))
				this.snackbarLinkText = ''
				this.snackbarTextAfter = ''
				this.snackbar = true
			} finally {
				this.overlay = false
			}
		},
	},
	watch: {
		'$i18n.locale': {
			immediate: false,
			async handler() {
				this.overlay = true
				await this.translateRecommendations()
				this.overlay = false
			}
		},
		isMatching: {
			deep: true,
			handler: function () {
				this.progressValue = 0
				let timer = 0
				this.interval = setInterval(() => {
					if (this.progressValue >= 98) {
						clearInterval(this.interval)
						return;
					}
					
					timer += 0.1;

					if (timer <= 30) {
						this.progressValue += 4 / 15
					} else if (timer > 30 && timer <= 60) {
						this.progressValue += 1 / 60
					} else if (timer > 60 && timer <= 120) {
						this.progressValue += 1 / 75
					}

					if (this.progressValue > 98) {
						this.progressValue = 98;
						clearInterval(this.interval)
					}
				}, 100)
			}
		},
		isPdfAnalyzing: {
			deep: true,
			handler: function () {
				this.progressValue = 0
				this.progressStatusText = String(this.$t('businessMatchHome.progressStatus.analyzingRequest'))
				let timer = 0
				this.interval = setInterval(() => {
					if (this.progressValue >= 99) {
						clearInterval(this.interval)
						return;
					}
					
					timer += 0.1;

					// 50 秒分成兩部分：前 3/5 (30秒) 和後 2/5 (20秒)
					if (timer <= 30) {
						// 前 3/5：分析您的需求
						this.progressStatusText = String(this.$t('businessMatchHome.progressStatus.analyzingRequest'))
						this.progressValue = (timer / 30) * 60  // 0-60%
					} else if (timer > 30 && timer <= 50) {
						// 後 2/5：生成結果
						this.progressStatusText = String(this.$t('businessMatchHome.progressStatus.generatingResults'))
						this.progressValue = 60 + ((timer - 30) / 20) * 39  // 60-99%
					}

					if (this.progressValue > 99) {
						this.progressValue = 99;
						clearInterval(this.interval)
					}
				}, 100)
			}
		},
		isKeywordAnalyzing: {
			deep: true,
			handler: function () {
				this.progressValue = 0
				this.progressStatusText = String(this.$t('businessMatchHome.progressStatus.analyzingRequest'))
				let timer = 0
				this.interval = setInterval(() => {
					if (this.progressValue >= 99) {
						clearInterval(this.interval)
						return;
					}
					
					timer += 0.1;

					// 15 秒分成四等分，每等分 3.75 秒
					if (timer <= 3.75) {
						// 第一等分：分析您的需求
						this.progressStatusText = String(this.$t('businessMatchHome.progressStatus.analyzingRequest'))
						this.progressValue = (timer / 3.75) * 24.75  // 0-24.75%
					} else if (timer > 3.75 && timer <= 7.5) {
						// 第二等分：搜尋相關廠商
						this.progressStatusText = String(this.$t('businessMatchHome.progressStatus.searchingExhibitors'))
						this.progressValue = 24.75 + ((timer - 3.75) / 3.75) * 24.75  // 24.75-49.5%
					} else if (timer > 7.5 && timer <= 11.25) {
						// 第三等分：智慧配對中
						this.progressStatusText = String(this.$t('businessMatchHome.progressStatus.smartMatching'))
						this.progressValue = 49.5 + ((timer - 7.5) / 3.75) * 24.75  // 49.5-74.25%
					} else if (timer > 11.25 && timer <= 15) {
						// 第四等分：生成結果
						this.progressStatusText = String(this.$t('businessMatchHome.progressStatus.generatingResults'))
						this.progressValue = 74.25 + ((timer - 11.25) / 3.75) * 24.75  // 74.25-99%
					}

					if (this.progressValue > 99) {
						this.progressValue = 99;
						clearInterval(this.interval)
					}
				}, 100)
			}
		}
	},
	async created() {
		this.overlay = true
		await Promise.all([
			this.getMe(),
			this.getPlatformIndustryList(),
			this.getHomeRecommendation()
		])

		// 在 getPlatformIndustryList() 完成後，將英文的行業名稱轉換為當前語言
		if (this.userDto.companyIndustry && this.userDto.companyIndustry.length > 0) {
			this.industry = this.userDto.companyIndustry.map(englishIndustry => {
				return this.platformIndustryKeyValue[englishIndustry] || englishIndustry
			})
		}

		this.overlay = false

		// 等 overlay 結束後再顯示 profileReminderSnackbar
		if(this.pendingProfileReminderSnackbar){
			this.profileReminderSnackbar = true
			this.pendingProfileReminderSnackbar = false
		}
	}
});
